import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core"
import { Observable } from "rxjs";
import { AuthenticationService } from "./authentication.service";
import { Url_Base } from 'app/rest-constants';


/** UUID of the DenverMattress Service Instance created in Edgefinity.  Holds configuration / setting values. */
const EfDenverMattressServiceUuid = "018fc97a-8cbb-7a46-8cd5-65a569a0a832";


@Injectable()
export class DenverMattressService {

  constructor(
    private authenticationService: AuthenticationService,
    private httpClient: HttpClient,
  ) { }

  /*
   * Calls the Edgefinity API to get the order information & state for the Portal Validation process.
  */
    public getValidationInfo(portalId: number | string): Observable < ValidationInfo > {
  const requestUrl = `${Url_Base}/denver-mattress/portal-validation/id/${portalId}/get-info`;
  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': this.authenticationService.getToken()
  });
  return this.httpClient.get<any>(requestUrl, { headers: headers });
}

/**
 * Clears the Order upon clicked by the user on UI button element
 * @param portalId 
 * @returns 
 */
    public clearOrderInfo(portalId: number | string): Observable < ValidationInfo > {
  const requestUrl = `${Url_Base}/denver-mattress/portal-validation/id/${portalId}/clear-order`;
  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': this.authenticationService.getToken()
  });
  return this.httpClient.post<any>(requestUrl, null, { headers: headers });
}

/**
 *  Get the Reader Status of the attached reader using the partalId
 * @param portalId Used to get the reader Status
 * @returns 
 */
    public getReaderStatus(portalId: number | string): Observable < String > {
      const requestUrl = `${Url_Base}/denver-mattress/portal-validation/id/${portalId}/get-reader-status`;
  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept':'application/json',
    'Authorization': this.authenticationService.getToken()
  });
  return this.httpClient.post<String>(requestUrl, null, { headers: headers });
}

/**
 * Start the Reader associated with the Portal 
 * @param portalId 
 * @returns 
 */
    public startReader(portalId: number | string): Observable < void> {
  const requestUrl = `${Url_Base}/denver-mattress/portal-validation/id/${portalId}/start-reader`;
  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': this.authenticationService.getToken()
  });
  return this.httpClient.post<void>(requestUrl, null, { headers: headers });
}

/**
 *  Stop the Reader associated with the Portal 
 * @param portalId 
 * @returns 
 */
    public stopReader(portalId: number | string): Observable < void> {
  const requestUrl = `${Url_Base}/denver-mattress/portal-validation/id/${portalId}/stop-reader`;
  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': this.authenticationService.getToken()
  });
  return this.httpClient.post<void>(requestUrl, null, { headers: headers });
}

/**
 *  Validate the Order Line Items
 * @param portalId 
 * @param lineItems 
 * @returns 
 */
    public processValidation(portalId: number | string): Observable < void> {
  const requestUrl = `${Url_Base}/denver-mattress/portal-validation/id/${portalId}/process-validation-attempt`;
  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': this.authenticationService.getToken()
  });
  return this.httpClient.post<void>(requestUrl, null, { headers: headers });
}


}


/** UUID of the 'DenverMattress Portal Validation' Service Type */
export const DenverMattressPortalServiceTypeUuid: string = '018fa556-5a6f-7946-a621-1ac753583769';


export enum ValidationState {
  /** Not currently processing an Validation Attempt */
    WaitingOnOrderInfo = 'WaitingOnOrderInfo',
  /** Loading the information for a Validation Attempt */
  LoadingOrderInfo = 'LoadingOrderInfo',
  /** Currently attempting to validate an Order */
  ValidatingOrder = 'ValidatingOrder',
  /** Currently processing / saving a Validation Attempt */
  ProcessingOrder = 'ProcessingOrder',
}


export interface ValidationAttemptLineItem {
  sku:string;
  quantity_required: number;
  quantity_read: number;
}

export interface ValidationInfo {
  state: ValidationState;
  attempt: ValidationAttempt;
}

export interface ValidationAttempt {
  order_id : String;
  line_items : ValidationAttemptLineItem[];
}


export enum DenverMattressReaderStateEnum {
  Disconnected = 'Disconnected',
  Stopped = 'Stopped',
  Started = 'Started',
  Reconnecting = 'Reconnecting...',
  Restarting = 'Restarting...'
}

